import jszip from 'jszip';
window.JSZip = jszip;
import DataTable from 'datatables.net-dt';
import 'datatables.net-buttons/js/buttons.colVis.mjs';
import 'datatables.net-buttons/js/buttons.html5.mjs';
import 'datatables.net-buttons/js/buttons.print.mjs';
import 'datatables.net-buttons-dt';
import 'datatables.net-fixedheader-dt';
import 'datatables.net-keytable-dt';
import 'datatables.net-responsive-dt';
import 'datatables.net-searchbuilder-dt';
import 'datatables.net-staterestore-dt';
import select2 from 'select2';
import { sprintf } from 'sprintf-js';

// Custom components
import './scripts/components/utilities';
import './scripts/components/api-call';
import './scripts/components/query-string';
import './scripts/components/data-object';
import './scripts/components/charts';
import './scripts/components/settings-page-module';
import './scripts/components/table-coursesOverview';
import './scripts/components/table-courseSingleOverviewSummary';
import './scripts/components/table-courseSingle';
import './scripts/components/table-usersOverview';
import './scripts/components/table-userSingleOverview';
import './scripts/components/table-userSingleCoursesOverview';
import './scripts/components/table-userSingleCourseProgressSummary';
import './scripts/components/table-userSingleCourseLessons';
import './scripts/components/table-userSingleCourseTopics';
import './scripts/components/table-userSingleCourseQuizzes';
import './scripts/components/table-userSingleCourseAssignments';
import './scripts/components/table-userSingleCourseTinCan';
import './scripts/components/table-customReporting';
import './scripts/components/tables';
import './scripts/components/tabs';
import './scripts/components/config';
import './scripts/components/tin-can-report';
import './scripts/components/xapi-quiz-report';
import './scripts/components/admin-tincan-report-tab';
